module.exports = __webpack_public_path__ + "img/bs.538ec3e9.png";